export default "__VITE_ASSET__DBC8tj0b__"